import { render } from "./StoreTabGeneral.vue?vue&type=template&id=6b87b5d2&scoped=true&ts=true"
import script from "./StoreTabGeneral.vue?vue&type=script&lang=ts"
export * from "./StoreTabGeneral.vue?vue&type=script&lang=ts"

import "./StoreTabGeneral.vue?vue&type=style&index=0&id=6b87b5d2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b87b5d2"]])

export default __exports__